import { roles as roleTypes } from "commons/auth/roles";
import _ from 'lodash';

export default class Role {
  /**
   * Check if user has a specific role type
   * @param roles array of user roles
   * @param type 'DEFAULT' | 'ADMIN' | 'RESEARCHER' | 'READONLY' | 'ANY'
   */
  public static hasRoleType(
    roles: string[],
    type: 'DEFAULT' | 'ADMIN' | 'RESEARCHER' | 'READONLY' | 'ANY'
  ): boolean {
    switch (type) {
      case 'DEFAULT':
        return roles.length === 1 && roles.includes('ROLE_USER');
      case 'ADMIN':
        return roles.some((r) => roleTypes.admin.includes(r));
      case 'RESEARCHER':
        return roles.some((r) => roleTypes.researcher.includes(r));
      case 'READONLY':
        return roles.some((r) => roleTypes.readonly.includes(r));
      case 'ANY':
        return roles.length > 0;
      default:
        return false;
    }
  }

  /**
   * Extract unique roles from user profile and permission matrix
   * @param userProfile
   * @param roleMatrix
   * @returns string[]
   */
  public static extractRoles(
    userProfile: { roles: string[]; email: string },
    roleMatrix: { roleNames: string[]; userNames: string[] }[]
  ): string[] {
    const matchedRoles: string[] = [];

    roleMatrix?.forEach((entry) => {
      if (
        entry.roleNames.some((r) => userProfile.roles.includes(r)) ||
        entry.userNames.includes(userProfile.email)
      ) {
        matchedRoles.push(...entry.roleNames);
      }
    });

    return _.uniq(matchedRoles);
  }

  /**
   * Check if user has only default role
   * @param roles
   */
  public static hasOnlyDefaultRole(roles: string[]): boolean {
    return Array.isArray(roles) &&
      roles.length === 1 &&
      roles.includes('ROLE_USER');
  }
}

